"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { forwardRef } from "react";

type SignupLinkProps = Omit<React.ComponentProps<typeof Link>, "href">;

const SignupLink = forwardRef<HTMLAnchorElement, SignupLinkProps>(
  ({ children, ...props }, ref) => {
    const pathname = usePathname();

    return (
      <Link
        href={`/auth?returnUrl=${encodeURIComponent(pathname)}`}
        ref={ref}
        {...props}
      >
        {children}
      </Link>
    );
  }
);

SignupLink.displayName = "SignupLink";

export default SignupLink;
